"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var use_stores_1 = require("hooks/use-stores");
var Breadcrumb_1 = __importDefault(require("components/common/navigation/Breadcrumb"));
var use_dialog_1 = require("hooks/use-dialog");
var use_notification_1 = require("hooks/use-notification");
var TableHeading_1 = require("components/common/table/TableHeading");
var FilterBar_1 = __importDefault(require("components/common/table/FilterBar"));
var Pager_1 = __importDefault(require("components/common/table/Pager"));
var ProductSubCategoriesTable_1 = __importDefault(require("./ProductSubCategoriesTable"));
var ProductSubCategoriesCreateBar_1 = __importDefault(require("./ProductSubCategoriesCreateBar"));
var utils_1 = require("../../../util/utils");
var Dialog_1 = require("../../Dialog");
var Notification_1 = require("../../Notification");
var ProductSubCategories = mobx_react_1.observer(function () {
    var _a = use_stores_1.useStores(), productSubCategoriesStore = _a.productSubCategoriesStore, prefsStore = _a.prefsStore, productsStore = _a.productsStore, productPageStore = _a.productPageStore;
    var _b = react_1.useState(false), transition = _b[0], setTransition = _b[1];
    var _c = react_1.useState(0), offset = _c[0], setOffset = _c[1];
    var prefs = prefsStore.data.productSubCategoriesTable;
    var perPage = prefs.perPage;
    var transitionTimeout = react_1.useRef(null);
    var dialog = use_dialog_1.useDialog();
    var notification = use_notification_1.useNotification();
    var search = function (searchValue) {
        var regEx = new RegExp(searchValue.trim(), 'gi');
        var searchArray = [];
        for (var _i = 0, _a = productSubCategoriesStore.data; _i < _a.length; _i++) {
            var productSubCategory = _a[_i];
            if (regEx.test(productSubCategory.name)) {
                searchArray.push(productSubCategory);
            }
        }
        return searchArray;
    };
    var _d = react_1.useState(prefs.search.length > 0), useSearch = _d[0], setUseSearch = _d[1];
    var _e = react_1.useState(useSearch ? search(prefs.search) : []), searchResults = _e[0], setSearchResults = _e[1];
    var getData = function () {
        if (!productSubCategoriesStore.data || productSubCategoriesStore.data.length <= 0) {
            api_1.default.getProductSubCategories()
                .then(function (response) { productSubCategoriesStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
        if (!productsStore.data || productsStore.data.length <= 0) {
            api_1.default.getProducts(prefsStore.data.productsTable.page, prefsStore.data.productsTable.perPage, (prefsStore.data.productsTable.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefsStore.data.productsTable.sort.name !== null ? prefsStore.data.productsTable.sort.name : 'id'), prefsStore.data.productsTable.search)
                .then(function (response) {
                productsStore.setData(response.data.products);
                productPageStore.setData(response.data.page);
            })
                .catch(api_1.catchHandler);
        }
    };
    var sortData = function (name, direction) {
        if (name === void 0) { name = null; }
        if (direction === void 0) { direction = TableHeading_1.TableDirections.UP; }
        var sortType = { name: name, direction: direction };
        if (sortType.name === null)
            return [];
        var sortName = sortType.name.toLowerCase();
        var sortDirection = sortType.direction;
        var ogArray = useSearch ? searchResults : productSubCategoriesStore.data;
        return ogArray.slice().sort(function (a, b) {
            if (sortName === 'products') {
                sortName = 'count';
            }
            var aSort = a[sortName];
            var bSort = b[sortName];
            if (sortName === 'parent category') {
                aSort = a.productCategory.name;
                bSort = b.productCategory.name;
            }
            if (aSort < bSort)
                return sortDirection === TableHeading_1.TableDirections.UP ? -1 : 1;
            if (aSort > bSort)
                return sortDirection === TableHeading_1.TableDirections.UP ? 1 : -1;
            return 0;
        });
    };
    var _f = react_1.useState(prefs.sort.name !== null), useSort = _f[0], setUseSort = _f[1];
    var _g = react_1.useState(useSort ? sortData(prefs.sort.name, prefs.sort.direction) : []), sortResults = _g[0], setSortResults = _g[1];
    react_1.useEffect(function () {
        document.title = 'Shop CMS - Product Subcategories';
        getData();
    }, []);
    react_1.useEffect(function () {
        setSearchResults(useSearch ? search(prefs.search) : []);
        setSortResults(useSort ? sortData(prefs.sort.name, prefs.sort.direction) : []);
    }, [productSubCategoriesStore.data.length]);
    var perPageHandler = function (value) {
        var old = prefs.perPage;
        prefsStore.editData({
            productSubCategoriesTable: __assign(__assign({}, prefs), { perPage: value })
        });
        if (value <= old)
            setOffset(Math.floor(offset / 2));
    };
    var searchHandler = function (value) {
        prefsStore.editData({
            productSubCategoriesTable: __assign(__assign({}, prefs), { search: value })
        });
        var searchProductSubCategories = search(value);
        if (searchProductSubCategories.length >= 0) {
            setSearchResults(searchProductSubCategories);
            setOffset(0);
        }
        setUseSearch(value.length >= 0);
    };
    var sortHandler = function (name, direction) {
        prefsStore.editData({
            productSubCategoriesTable: __assign(__assign({}, prefs), { sort: {
                    name: name,
                    direction: direction
                } })
        });
        if (name !== null) {
            setSortResults(sortData(name, direction));
        }
        setUseSort(name !== null);
    };
    var pageHandler = function (page) {
        var max = Math.ceil(productSubCategoriesStore.data.length / prefs.perPage) - 1;
        if (page === offset)
            return;
        if (offset === max && page >= max)
            return;
        if (offset === 0 && page <= 0)
            return;
        setTransition(true);
        clearTimeout(transitionTimeout.current);
        transitionTimeout.current = setTimeout(function () {
            setTransition(false);
            setOffset(utils_1.clamp(0, page, max));
        }, 200);
    };
    var deleteHandler = function (productSubCategory) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(productSubCategory.count > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dialog({
                            variant: Dialog_1.DialogVariants.ALERT,
                            title: 'Cannot delete subcategory',
                            description: 'This subcategory still contains products, therefore you cannot delete it. Please reassign the products to a different category or subcategory before deleting this subcategory.'
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2:
                    dialog({
                        variant: Dialog_1.DialogVariants.CONFIRMATION,
                        title: "Delete " + productSubCategory.name,
                        description: 'Are you sure you want to delete this product subcategory?'
                    })
                        .then(function () {
                        api_1.default.deleteProductSubCategory(productSubCategory)
                            .then(function () {
                            productSubCategoriesStore.removeDataItem(productSubCategory);
                            notification({
                                variant: Notification_1.NotificationVariants.SUCCESS,
                                message: 'Product subcategory has been deleted'
                            });
                        })
                            .catch(api_1.catchHandler);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var currentPage = offset * perPage;
    return (react_1.default.createElement("div", { className: 'product-sub-categories page', "data-transition": transition },
        react_1.default.createElement(Breadcrumb_1.default, { items: [
                { text: 'Products', href: '/products' },
                { text: 'Product Subcategories', href: '/products/sub-categories' }
            ] }),
        react_1.default.createElement(ProductSubCategoriesCreateBar_1.default, null),
        react_1.default.createElement(FilterBar_1.default, { label: 'Subcategories', perPage: prefs.perPage, onPerPageChange: perPageHandler, searchValue: prefs.search, onSearchChange: searchHandler }),
        react_1.default.createElement(ProductSubCategoriesTable_1.default, { sort: prefs.sort, data: useSearch && searchResults.slice(currentPage, currentPage + perPage) ||
                useSort && sortResults.slice(currentPage, currentPage + perPage) ||
                productSubCategoriesStore.data.slice(currentPage, currentPage + perPage), products: productsStore.data, onChangeSort: sortHandler, onDelete: deleteHandler }),
        react_1.default.createElement(Pager_1.default, { itemsLength: useSearch ?
                searchResults.length === 0 ? 0 : searchResults.length :
                useSort ?
                    sortResults.length === 0 ? 0 : sortResults.length :
                    productSubCategoriesStore.data.length, offset: offset, perPage: prefs.perPage, onPrev: function () { return pageHandler(offset - 1); }, onNext: function () { return pageHandler(offset + 1); }, onPage: pageHandler })));
});
exports.default = ProductSubCategories;
